/* eslint-disable camelcase */
// camel case fix for layer_id
import { Component, OnInit, Input, Renderer2, ViewEncapsulation, HostListener } from "@angular/core";
import { QueryLayersService } from "../services/query-layers.service";
import { AssetDetailService } from "../services/asset-detail.service";
import { Globals } from "../shared/globals";
import { AuthenticationService } from "src/app/services/authentication.service";
import { IUser } from "src/app/interface/user";
import { environment } from "src/environments/environment";
import { GenericLayerService } from "../services/generic-layer.service";
import Swal from "sweetalert2";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { EsriMapComponent } from "src/app/esri-map/esri-map.component";
import { CardViewService } from "src/app/services/card-view.service";
import { AssetAttributesService } from "../services/asset-attributes.service";
import { EventEmittersService } from "../services/event-emitters.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "src/app/services/user.service";
import { faAngleDown, faAngleUp, faChevronLeft, faChevronRight, faPlus } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
//TSDRSAM-1099 By Manikantha  -->
import { isNumeric } from "rxjs/internal-compatibility";
import { GenericMapMethodsService } from "../services/generic-map-methods.service";
import { BASE64_PREFIX } from "src/app/shared/utils";
import { CustomTranslatePipe } from "../shared/custom-translate.pipe";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { FormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { ConfigurableHeaderComponent } from "../shared/configurable-header/configurable-header.component";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { AssetDetailComponent } from "./asset-detail/asset-detail.component";
import { NgIf, NgFor, NgClass, SlicePipe, DatePipe, NgStyle } from "@angular/common";
import { ILayerSelections } from "../interface/selectedSet";
import { ILayer } from "../interface/layer";
import { ITableAliasesRow } from "../interface/other";
import { IRelationshipInfo } from "../interface/relationshipInfo";


enum paginationType {
  First,
  Previous,
  Next,
  Last
}
@Component({
    selector: "sms-asset-viewer",
    templateUrl: "./asset-viewer.component.html",
    styleUrls: ["./asset-viewer.component.scss"],  // 8/13/26 asset-viewer used to be under select folder
    encapsulation: ViewEncapsulation.None,
    styles: [
        `
           .dark-modal .modal-content {
             position: relative;
             display: flex;
             flex-direction: column;
             width: 127%;
             pointer-events: auto;
             /* background-color: #fff; */
             /* background-clip: padding-box; */
             /* border: 1px solid rgba(0, 0, 0, 0.2); */
             /* border-radius: 0.3rem; */
             background-color: transparent;
             outline: 0;
             align-items: flex-end;
             box-shadow: 0px 0px 0px rgba(0, 0, 0, 1) !important;
           }
           .dark-modal .close {
             color: white;
           }
           .light-blue-backdrop {
             background-color: #5cb3fd;
           }
         `
    ],
    standalone: true,
    imports: [NgIf, AssetDetailComponent, CdkDrag, ConfigurableHeaderComponent, CdkDragHandle, MatFormFieldModule, MatSelectModule, FormsModule, NgFor, MatOptionModule, NgClass, MatButtonModule, MatIconModule, SlicePipe, DatePipe, TranslateModule, CustomTranslatePipe, NgStyle]
})

//OnChanges
export class AssetViewerComponent implements OnInit {
  // Objects
  // @ViewChild(AssetDetailComponent, { static: false })
  // assetDetails: AssetDetailComponent;
  // ******Input Variables***********

  // Map Related Classes Start
  @Input() AI: any;   // AttributeInspector - not used here. passed into asset-detail-component but not used there either.
  @Input() map: any;
  @Input() Editor: any;
  @Input() Query: any;
  @Input() RelationshipQuery: any;
  @Input() FeatureLayer: any;
  @Input() Draw: any; // Draw Point / Line / Polygon to add a new Feature
  @Input() webMercatorUtils: any; // Convert to Webmercator cordinates 4326
  @Input() Graphic: any;
  @Input() Color: any;
  @Input() SimpleMarkerSymbol: any;
  @Input() SimpleLineSymbol: any;
  @Input() Edit: any;
  @Input() QueryTask: any;
  @Input() geometryEngine: any;
  @Input() Polygon: any;
  @Input() geometryJsonUtils: any;
  @Input() isFromQB: any;
  @Input() Point: any;
  // Map Related Classes End

  // Data Start
  @Input() selectedSet: ILayerSelections[] = [];
  // Data From Parent End
  
  // inputs not referenced:
  @Input() layerData: any;
  @Input() regionData: any;
  @Input() attribs: any;
  @Input() selLayerindex: number = 0; // 0 by default
  @Input() selectedIndex: number = 0;



  // Icons
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  faAngleUp = faAngleUp;
  faAngleDown = faAngleDown;
  faPlus = faPlus;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;



  activeFeature: any[] = [];      // uber array for active feature
  activeAsset: any[] = [];        // uber array for active feature or child asset
  activeAssetId: string = '';     //9/22/20 -- the support and a related sign can both have the same ObjectID (unique to their table), so using it to determine which is active for purposes of highlighting the card is problematic.  Refactor to use activeAssetID
 
  childRelationshipInfo: IRelationshipInfo[] = [];
 
  selectedLyrObj: any;
  selectedLayerName: string = ""; // any = []; // 0 index- First Layer By default
  selectedLayerInfo: ILayer;
  selectedCount: number = 0; // Number of features in selected Layer 

  relatedAssetToAdd: string = '';   // 'Sign' or 'Light' selected from asset viewer Header's Add button
 
  doNotReplaceDomain;
  featureLayer;
  asset;
  relasstClickedES = [true, true, true, true, true];
  assetViewerLabel: any;
  lightAddAccess;
  signAddAccess;

  showreshape;
  showAssetDtl = false;
  isShown = true; // hidden by default
  loading = false; // Loading Control //

  // Adding New Assets
  expand = this.translateService.instant("Select.carddisplay.expand");
  minimize = this.translateService.instant("Select.carddisplay.minimize");
  newChildId;
  dataEditorSettings;
  //relatedFeatures: any = [];            // 2/22/26 relationship class??
  counter = 0;
  parenttasksCount; // number of tasks assigned to parent ;   10/9/26 value is set but never used. 
  // layerName: any;
  
  assetTypeId;
  rollbackData: any = {};
  tableAliases: any = {};
  
  ftrLyrTblMaintenance;
  ftrLyrActivity;
  
  // Esri Tool Intractions
  draw: any;
  clickMap: any;
  selectionSymbol;
  
  // Events
  eventemitSelectedLayerIndexOnData;
  eventemitSelectedParentIndexOnData;
  eventemitSelectedFeaturesOnMap;
  eventgenericLayerService;
  eventEmitTaskCreated;
  eventEmitchildDeleted;
  eventEmitCloseModel;
  eventEmitTaskCompleted;
  eventEmitreplaceTaskCreated;
  eventemitSelectedData;

  assessmentlyr;
  currentUser: IUser;
  isDataEditor: boolean;
  // Added by Abhilash for JIRA ID:-34 on 08/12/2021
  fieldsInfo = [];        // fields customer has configured for display on spatial asset card
  fieldsInfoLight = [];   // fields customer has configured for display on light card
  fieldsInfoSign = [];    // fields customer has configured for display on sign card
  result;
  isDeleteClicked: boolean;
  showChildCard: boolean;
  title = "appBootstrap";

  closeResult: string;
  closeOpenModelService: any;
  mymodelIsVisible = false;
  counterVar;
  dotGraphics;
  openTasksJson: any;
  newChildFeature: any;
  newChildFClass: any;

  //visualization layers
  visualizationLayersData;
  visualizationAssetIsActive:boolean = false;
  currentVisualizationDataIndex = 0;
  activeVisualizationRecord; //
  
  reshapeIconDiv;
  relocateIconDiv;
  visibleInventoryLayers: ILayer[] = [];

  //Added for ADAsrc/app/esri-map/esri-map.component.ts
  @HostListener("document:keydown.enter", ["$event"])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.target["localName"] === "div" && ["assestViewerbtn", "cardViewClose", "assetCard", "assetCard1", "assetCard2", "assetCard3", "assetCard4"].includes(event.target["id"])) {
      (<HTMLInputElement>event.target).click();
    }
  }
  //
  constructor(
    private queryLayersService: QueryLayersService,
    private genericLayerService: GenericLayerService,
    public assetDetailService: AssetDetailService,
    public objGlobal: Globals,
    private renderer: Renderer2,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
    private cardViewService: CardViewService,
    public esritools: EsriMapComponent,
    private assetAttributesService: AssetAttributesService,
    public eeService: EventEmittersService,
    private modalService: NgbModal,
    public userService: UserService,
    //TSDRSAM-1099 By Manikantha  -->
    public genericMapMethodsService: GenericMapMethodsService
  ) {
    this.userService.getRoleslist().subscribe((evt) => {
      this.objGlobal.userRoles = evt;
    });
    this.closeOpenModelService = modalService;
    this.queryLayersService.FeatureLayer = this.FeatureLayer;
    this.currentUser = this.authenticationService.currentUserValue;
    //TSDRSAM-1099 By Manikantha  -->
    this.genericMapMethodsService.currentUser = this.currentUser;
    this.setReplaceYearData();


    // subscriptions 

    //visualization layers
    this.eventemitSelectedData = this.eeService.emitSetVisualizationAssetViewer.subscribe((res) => {
      // selected visualization layers updated
      this.visualizationLayersData = res;
    });
    //
    this.eventemitSelectedFeaturesOnMap = this.eeService.emitSelectedFeaturesOnMap.subscribe((res) => {
      this.selectedSet = res;
      this.selectedCount = this.selectedSet.length;
      if (this.selectedCount > 0) {
        this.reloadAssetViewer();
      }
    });
    this.eventemitSelectedParentIndexOnData = this.eeService.emitSelectedParentIndexOnData.subscribe((res) => {
      this.loadSelectedParentFeatureInView();
    });

    this.eventemitSelectedLayerIndexOnData = this.eeService.emitSelectedLayerIndexOnData.subscribe(
      (result) => {
        // #TFS 25016
        if (!this.selectedSet || this.selectedSet.length === 0) {
          this.selectedLayerName = this.eeService.userLayers[this.eeService.selectedLayerIndex].name;
        }
        // #TFS 25016
        else {
          this.selectedLayerName = this.selectedSet[this.eeService.selectedLayerIndex].LayerInfo.name;
        }
        this.layerChanged();
        // this.layerChanged(this.eeService.selectedLayerIndexOnData);
      }
    );

    this.eventEmitTaskCreated = this.eeService.emitTaskCreated.subscribe(() => {
      this.loadSelectedParentFeatureInView();
    });
    this.eventEmitchildDeleted = this.eeService.emitchildDeleted.subscribe(() => {
      this.loadSelectedParentFeatureInView();
    });
    this.eventEmitCloseModel = this.eeService.emitCloseModel.subscribe(() => {
      this.closeModel();
    });
    this.eventEmitTaskCompleted = this.eeService.emitTaskCompleted.subscribe(() => {
      this.loadSelectedParentFeatureInView();
    });
    this.eventEmitreplaceTaskCreated = this.eeService.emitreplaceTaskCreated.subscribe(() => {
      this.loadSelectedParentFeatureInView();
    });
  }

  open(content) {
    try {
      this.mymodelIsVisible = true;
      this.closeOpenModelService.open(content, { windowClass: "dark-modal" }).result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
    } catch (error) {
      console.error(error);
    }
  }
  closeModel(): void {
    try {
      // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
      this.eeService.setEnableSingleClick(true);
      this.mymodelIsVisible = false;
      this.closeOpenModelService.dismissAll();
      //this.closeOpenModelService.close();
      this.reloadAssetViewer();

      // const object = {} //={layerName:selectedAssetslist.split(',')};
      // const layerName = this.selectedLayer;
      // object[layerName] = [this.selectedFeature[0].AssetID];

      // this.genericLayerService.getOpentasks(object).subscribe((opentasksRes: any) => {
      //   this.openTasksJson = JSON.parse(opentasksRes);
      //   this.updateChildFeaturesTaskCount()
      // // RSAM Bug Fix JIRA ID: 333
      //     if (JSON.parse(opentasksRes).OpenTaskByAsset[0][this.selectedLayer]) {
      //       this.activeParentAsset[5]['task'] = JSON.parse(opentasksRes).OpenTaskByAsset[0][this.selectedLayer][0].OpenTaskCount;
      //     }
      // })
    } catch (error) {
      console.error(error);
    }
  }
  private getDismissReason(reason: any): string {
    try {
      if (reason === ModalDismissReasons.ESC) {
        return "by pressing ESC";
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return "by clicking on a backdrop";
      }
      // else {
      //   return `with: ${reason}`;
      // }
      return `with: ${reason}`;
    } catch (error) {
      console.error(error);
    }
  }
  ngOnInit() {
    this.reloadAssetViewer();
    this.assessmentlyr = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.assessmentId, { outFields: ["*"] });

    //Jira Id 935
    this.assetDetailService.getAssetIDFormat(this.Query, this.QueryTask, this.FeatureLayer);
    //ADA fix
    //document.getElementById("cardViewClose").focus();
  }
  ngOnDestroy() {
    if (this.draw) {
      this.draw.finishDrawing();
      this.draw.deactivate();
      this.draw = null;
    }
    if (this.clickMap) {
      this.clickMap.remove();
    }
    try {
      this.eventemitSelectedLayerIndexOnData.unsubscribe();
      this.eventemitSelectedParentIndexOnData.unsubscribe();
      this.eventemitSelectedFeaturesOnMap.unsubscribe();
      this.eventEmitTaskCreated.unsubscribe();
      this.eventEmitchildDeleted.unsubscribe();
      this.eventEmitCloseModel.unsubscribe();
      this.eventEmitTaskCompleted.unsubscribe();
      this.eventEmitreplaceTaskCreated.unsubscribe();
    } catch (error) {
      console.log(error);    // 9/24/26 asset viewer had difficulty toggling off and back on when there was an uncaught error during unsubscribe
    }
  }

  reloadAssetViewer() {
    try {
      this.selectedSet = this.eeService.selectedSet;    // should be set prior
      //Added for visualization layers
      this.visualizationLayersData = this.eeService.visualizationLyrData;

      const onlyVisualizationLayers =  this.selectedSet.every( (l) => { return l.LayerInfo.type == 'visualization' }) && this.selectedSet.length > 0; // every returns true if all elements satisfy the condition AND returns true for an empty array (vacuous truth).

      if (onlyVisualizationLayers) {
        let vis = this.visualizationLayersData[0];
        this.activeVisualizationRecord = vis.Data[0].attributes;
        this.visualizationAssetIsActive = true;
        this.activeFeature = [];
        this.showChildCard = false;
        this.selectedCount = vis.Data.length;
        this.selectedLayerName = vis.LayerInfo.name;
        this.genericMapMethodsService.setActiveVisualizationAsset(vis.Data[0].geometry);
        this.eeService.setShowVisualizationAssetDetails(this.selectedLayerName, this.activeVisualizationRecord);
        this.selectedSet = this.visualizationLayersData;
        this.assetViewerLabel = this.translateService.instant("AssetViewer.Title");
        this.loadSelectedParentFeatureInView();
      } else {

        // If feature is support show Add Child Asset button
        const lightlyr = this.currentUser.assignedAssetClasses.find( (ac) => { return ac.layerId === this.currentUser.tableIds.lightId; });
        const signlyr = this.currentUser.assignedAssetClasses.find( (ac) => { return ac.layerId === this.currentUser.tableIds.signId; });
        this.lightAddAccess = lightlyr?.accessPrivilege === "Data Editor";
        this.signAddAccess = signlyr?.accessPrivilege === "Data Editor";

        this.assetAttributesService.getTableAlias().subscribe((tblresults: any) => {
          tblresults.features.forEach((f) => {
            this.tableAliases[f.attributes.Name] = this.currentUser.scndLang ? f.attributes.Alias_SL : f.attributes.Alias;
          });
        });

        // For Selection Assets
        this.dataEditorSettings = JSON.parse(localStorage.getItem("dataEditorSettings") || "{}");

        if (this.selectedSet?.length > 0) {
          this.assetViewerLabel = this.translateService.instant("AssetViewer.Title");
          this.selectedLayerName = this.selectedSet[this.eeService.selectedLayerIndex].LayerInfo.name;
          this.selectedCount = this.selectedSet[this.eeService.selectedLayerIndex].Data.length;
          if (this.selectedSet[this.eeService.selectedLayerIndex].LayerInfo.lyrObj?.geometryType === "esriGeometryPolyline") {
            this.showreshape = true;
          } else {
            this.showreshape = false;
          }
          this.loadSelectedParentFeatureInView();
        } else {
          // Add tool for creating a new asset
          this.selectedLayerName = "";
          this.eeService.userLayers.filter(l => l.type === "inventory").forEach((lyr) => {
            lyr.lyrObj?.clearSelection();
          });
          this.assetViewerLabel = this.translateService.instant("Select.alertcarddisplay.createnewasset");
          if (this.currentUser.selectedLayer) {  // is this condition relevant?
            const selectedLayer = this.eeService.userLayers[this.eeService.selectedLayerIndex];
            this.selectedLayerName = selectedLayer.name;
            this.selectedLyrObj = selectedLayer.lyrObj;
            this.selectedLayerInfo = selectedLayer;
          } else {
            //9/12/26 limit Add Asset Class dropdown to visible layers
            this.visibleInventoryLayers = this.eeService.userLayers.filter((layer: ILayer) => layer.visible && layer.type === "inventory");
            this.selectedLayerName = this.visibleInventoryLayers[0].name;
            this.selectedLyrObj = this.visibleInventoryLayers[0].lyrObj;
            this.selectedLayerInfo = this.visibleInventoryLayers[0];

          }
          this.addNewAsset();
        }

      }

    } catch (error) {
      console.error(error);
    }
  }
  //   // Load Parent Class Feature for Card View
  showParentAssetCard(layerName) {        //OBSOLETE? never called
    try {
      this.eeService.toggleCardView(layerName);
    } catch (error) {
      console.error(error);
    }
  }

  loadSelectedParentFeatureInView() {
    try {
      const selectedFeatureArray = [];
      this.selectedSet = this.eeService.selectedSet; // multiple spatial asset class layers can be shown on map and assets
                                                     // from each can be selected at same time.  this.selectedSet is array 
                                                     // of objects representing the total selected set, w/object per 
                                                     // asset class. these objects have 2 properties: 
                                                     //      'Data' (array of selected assets)
                                                     //      'LayerInfo' (object with accessPrivilege, layerId, etc props)
      const layerIndex = this.eeService.selectedLayerIndex;   // Index, in this.selectedSet, of the 
                                                                    // layer currently loaded into Asset Viewer (i.e. the layer 
                                                                    // selected in the layer dropdown in header)
      const featureIndex = this.eeService.selectedFeatureIndex // Index of active spatial asset (its summary info 
                                                                    // card is displayed in the Asset Viewer) in the Data array
      const activeFeature = this.selectedSet[layerIndex].Data[featureIndex];  // currently active spatial asset

      if (activeFeature) {
        // Construct asset uberArray
        selectedFeatureArray.push(activeFeature.attributes);   
        selectedFeatureArray.push(this.selectedSet[layerIndex].LayerInfo);
        selectedFeatureArray.push(activeFeature);
        selectedFeatureArray.push({ geometry: activeFeature.geometry });     // Add Active Asset geometry to array unless child element then adding parent geom to array

        let region;                                           //smallest region containing active asset. what purpose?
        if (activeFeature.attributes.Region4) {
          region = activeFeature.attributes.Region4;
        } else if (activeFeature.attributes.Region3) {
          region = activeFeature.attributes.Region3;
        } else if (activeFeature.attributes.Region2) {
          region = activeFeature.attributes.Region2;
        } else if (activeFeature.attributes.Region1) {
          region = activeFeature.attributes.Region1;
        }
        selectedFeatureArray.push({ region });

        selectedFeatureArray.push({ task: 0 });               // 7/29/20 jcc -- added this here to maintain expected array positin for task object -- referenced in view.

        const regions = {                                     //jcc 7/26/20 -- capture all regions for current asset
          region1: activeFeature.attributes.Region1,
          region2: activeFeature.attributes.Region2,
          region3: activeFeature.attributes.Region3,
          region4: activeFeature.attributes.Region4
        }; 
        selectedFeatureArray.push({ regions });

        const activeAssetObj = this.buildActiveAssetObject();  //test to see if I can create the active asset object correctly, separately from map symbology

        let att = selectedFeatureArray[0] == activeAssetObj.attributes;
        let lyr = selectedFeatureArray[1] == activeAssetObj.layerInfo;
        let feat = selectedFeatureArray[2] == activeAssetObj.feature;
        let geom = JSON.stringify(selectedFeatureArray[3].geometry) == JSON.stringify(activeAssetObj.geometry);
        let reg = JSON.stringify(selectedFeatureArray[4].region) == JSON.stringify(activeAssetObj.region);
        let task = JSON.stringify(selectedFeatureArray[5].task) == JSON.stringify(activeAssetObj.task);
        let regs = JSON.stringify(selectedFeatureArray[6].regions) == JSON.stringify(activeAssetObj.regions);


        // get open tasks
        if (selectedFeatureArray[0].AssetID) { // visualization layers (probably) do not have AssetID. Also some bad inventory assets are without AssetID
          const tasksFor: { [key: string]: string[] } = {[this.selectedLayerName]: [selectedFeatureArray[0].AssetID]}; 
          this.genericLayerService.getOpentasks(tasksFor).subscribe((opentasksRes: any) => {
            this.openTasksJson = JSON.parse(opentasksRes);
            this.normalizeOpenTasks();
          });
        }

        if (selectedFeatureArray[1].lyrObj.getDomain) {  // won't for visualization layers
          this.doNotReplaceDomain = selectedFeatureArray[1].lyrObj?.getDomain("DoNotReplace").codedValues;          //get Yes or No to display instead of 1 or 0. Visualization layers do not have lyrObj
        }


        this.activeFeature = selectedFeatureArray;
        this.eeService.setActiveAsset(selectedFeatureArray);
        
        this.getFieldsInfo(); // Added by Abhilash for JIRA ID:-34 on 08/12/2021

        //#region Jira-70
        if (this.activeFeature[0].AssetCode) {
          this.assetDetailService.getAssetIconAsBase64(this.currentUser.clientId, "en-US", this.activeFeature[0].AssetCode, true).subscribe(
            (base64Image: any) => {
              if (base64Image && this.activeFeature.length >= 7) {
                let ImageBase64 = {};
                ImageBase64 = BASE64_PREFIX + base64Image;
                this.activeFeature.splice(7, 0, { "ImageBase64": ImageBase64 });
              }
            },
            (error) => {
              if (error.status) {
                //console.log("No icon found", error);
                console.log("no icon: "  + this.activeFeature[0].AssetCode, "");
              }
            }
          );
        }
        //#endregion

        this.childRelationshipInfo = [];
        this.objGlobal.relatedAssetInfo = [];
        if (this.activeFeature) {
          this.assetDetailService.parentAsset = this.activeFeature;
        }
        if (this.selectedLayerName == "Support") {
          this.loadSelectedChildFeatureInView();
        } else {
          this.loading = false;
        }

        // }
      }
    } catch (error) {
      console.error(error);
    }
  }
  loadSelectedChildFeatureInView() {
    try {
      this.loading = true;
      this.queryLayersService.map = this.map;
      this.queryLayersService.RelationshipQuery = this.RelationshipQuery;
      this.queryLayersService.FeatureLayer = this.FeatureLayer;
      this.counter = 0;
      this.getRelatedDataDetails();
      // }
    } catch (error) {
      console.error(error);
    }
  }

  getRelatedDataDetails() {   // this is now getChildAssetRelationshipInfo
    this.childRelationshipInfo = [];

    const parentLayer: ILayerSelections = this.selectedSet[this.eeService.selectedLayerIndex];  
    const parentAssetID = parentLayer.Data[this.eeService.selectedFeatureIndex].attributes.AssetID;  //4/1/26 bug fix

    parentLayer.LayerInfo.lyrObj.relationships.forEach((r: any) => {

      const childAssetLayer = this.eeService.userLayers.find(({ layerId }) => layerId === r.relatedTableId);  
      if (childAssetLayer) {    // only process SupportTo<assigned asset> relationships. skip e.g. SupportToMaintenance, also skip child asset types not assigned to current user.

        this.childRelationshipInfo.push({ 
          name: r.name, 
          layer_id: r.relatedTableId, 
          label: (this.currentUser.scndLang ? childAssetLayer.aliasSL : childAssetLayer.alias) || "", 
          data: [] 
        });

        this.genericLayerService.getFilteredFeaturesByField(r.relatedTableId, "ParentID", parentAssetID).subscribe( (featuresInfos: any) => {
          this.counter++;

          if (featuresInfos?.features && featuresInfos.features[0]) {

            featuresInfos.features.sort(function (a, b) {
              let aMountHeight = a.attributes.MountHeight;
              let bMountHeight = b.attributes.MountHeight;
              if (aMountHeight == null) {
                aMountHeight = 0;
              }
              if (bMountHeight == null) {
                bMountHeight = 0;
              }
              const aOID = a.attributes.OBJECTID;
              const bOID = b.attributes.OBJECTID;
              if (aMountHeight == bMountHeight) {
                return aOID - bOID;    //jcc if same mountheight, sort newest to oldest
              } 
              return bMountHeight - aMountHeight;
            });

            //this.childRelationshipInfo.filter((info) => {   // shouldn't this be a forEach instead of filter?
            this.childRelationshipInfo.forEach((info) => {

              if (info.name === r.name) {
                info.data = featuresInfos.features.filter((item: any) => item.attributes.Status != "Inactive");
              }

              info.data.forEach((data) => {  //Jira-70
                this.assetDetailService.getAssetIconAsBase64(this.currentUser.clientId, "en-US", data.attributes.AssetCode, false).subscribe(
                  (base64Image: any) => {
                    if (base64Image) {
                      data.ImageBase64 = BASE64_PREFIX + base64Image;
                    }
                  },
                  (error) => {
                    if (error.status) {
                      console.log("no icon: " + data.attributes.AssetCode, "");
                    }
                  }
                );
              });

              if ( info.name.toLowerCase().includes("sign") || info.name.toLowerCase().includes("light") ) {  // Jira Id-34 Bug-TSDRSAM-1546
                info.data.forEach( (asset) => asset.attributes.codeAndDes = this.getCodedValue(asset, info.name) );
              }
            });
          }

          if (this.counter === this.childRelationshipInfo.length) {
            this.loading = false;
            this.selectChildAndOpenAtt();
            this.objGlobal.relatedAssetInfo = this.childRelationshipInfo;
            this.showChildCard = true;
            if (this.eeService.selectedChildClass) {
              const relatedRecords = this.childRelationshipInfo.find((info) => info.name.includes(this.eeService.selectedChildClass) );
              const childId = this.eeService.selectedChildAssetId;
              if (relatedRecords?.data && childId) {
                let childAsset = relatedRecords.data.find( (data) => data.attributes.AssetID == childId ) ?? 
                                  relatedRecords.data.find( (data) => data.attributes.AssetID == this.eeService.assetId );
                if (childAsset) {
                  this.openAssetDetail("Child", childAsset, relatedRecords);
                }
              }

              if (this.eeService.selectedChildAssetId == null) {
                // TSDRSAM-1070 By Manikantha V
                if (relatedRecords?.data) {
                  const childAsset = relatedRecords.data[0];
                  if (this.eeService.selectedChildClass == "Sign") {
                    this.eeService.toggleCardView("SupportToSign");
                  }
                  if (this.eeService.selectedChildClass == "Light") {
                    this.eeService.toggleCardView("SupportToLight");
                  }
                  //TSDRSAM-1654
                  if (childAsset && this.showAssetDtl == true) {
                    this.openAssetDetail("Child", childAsset, relatedRecords);
                  }
                } else {
                  if (this.eeService.selectedChildClass == "Sign") {
                    this.eeService.toggleCardView("SupportToSign", 0);
                  }
                  if (this.eeService.selectedChildClass == "Light") {
                    this.eeService.toggleCardView("SupportToLight", 0);
                  }
                }
              }
            }

            console.log("loading false");
            this.loading = false;
          }
        });
      }
    });

    if (this.childRelationshipInfo.length == 0) {
      this.loading = false;
    }
  }

  // Get Tasks related to Feature
  getTasksCount(childAssetInfo: any) {
    try {
      const maintLyr = childAssetInfo.filter((info) => info.name.includes("Maintenance")); // 7/28/20 jcc -- this maintenance layer holds assessment records??
      if (maintLyr[0]?.data?.length) {
        this.parenttasksCount = maintLyr[0].data.length;
      } else {
        this.parenttasksCount = 0;
      }
    } catch (error) {
      console.error(error);
    }
  }

  handlePagination(type: paginationType): void {
    try {
      let assetData;
      //if statement evaluating type
      switch (type) {
        case paginationType.First:
          if (this.visualizationAssetIsActive) {
            if (this.currentVisualizationDataIndex > 0) {
              this.currentVisualizationDataIndex = 0;
            }
          } else {
            if (this.eeService.selectedFeatureIndex > 0) {
              this.eeService.setSelectedFeatureIndex(0);
            }
          }
          break;
        case paginationType.Previous:
          if (this.visualizationAssetIsActive) {
            if (this.currentVisualizationDataIndex > 0) {
              this.currentVisualizationDataIndex = this.currentVisualizationDataIndex - 1;
            }
          } else {
            if (this.eeService.selectedFeatureIndex > 0) {
              this.eeService.setSelectedFeatureIndex(this.eeService.selectedFeatureIndex - 1);
            }
          }
          break;
        case paginationType.Next:
          if (this.visualizationAssetIsActive) {
            if (this.currentVisualizationDataIndex + 1 < this.selectedCount) {
              this.currentVisualizationDataIndex = this.currentVisualizationDataIndex + 1;
            }
          } else {
            if (this.eeService.selectedFeatureIndex < this.selectedCount - 1) {
              this.eeService.setSelectedFeatureIndex(this.eeService.selectedFeatureIndex + 1);
            }
          }
          break;
        case paginationType.Last:
          if (this.visualizationAssetIsActive) {
            if (this.currentVisualizationDataIndex + 1 < this.selectedCount) {
              this.currentVisualizationDataIndex = this.selectedCount - 1;
            }
          } else {
            if (this.eeService.selectedFeatureIndex < this.selectedCount - 1) {
              this.eeService.setSelectedFeatureIndex(this.selectedCount - 1);
            }
          }
          break;
      }
      if (this.visualizationAssetIsActive) {
        if (this.visualizationLayersData[0].LayerInfo.name) {
          assetData = this.visualizationLayersData.filter((e) => e.LayerInfo.name == this.selectedLayerName)[0];
        } else {
          assetData = this.visualizationLayersData.filter((e) => e.LayerInfo == this.selectedLayerName)[0];
        }
        this.activeVisualizationRecord = assetData.Data[this.currentVisualizationDataIndex].attributes;
        this.genericMapMethodsService.setActiveVisualizationAsset(assetData.Data[this.currentVisualizationDataIndex].geometry);
      }
    } catch (error) {
      console.error(error);
    }
  }

  layerChangedFromUi(changeEvent, idx) {
    //Updated for visualization layers
    if (changeEvent.isUserInput === true) {

      const visLyrData = this.visualizationLayersData?.find(e => e.LayerInfo.name == changeEvent.source.value);  //10/13/26 changed from LayerInfo.layerName
      this.activeVisualizationRecord = visLyrData?.Data[0]?.attributes ?? [];

      if (this.activeVisualizationRecord.length > 0) {    // layer was changed to a visualization record
        this.genericMapMethodsService.removePreviousActiveAsset();
        this.visualizationAssetIsActive = true;
        this.activeFeature = [];
        this.showChildCard = false;
        this.selectedCount = visLyrData.length;
        this.selectedLayerName = changeEvent.source.value;
        this.genericMapMethodsService.setActiveVisualizationAsset(visLyrData.geometry);
        this.eeService.setShowVisualizationAssetDetails(this.selectedLayerName, this.activeVisualizationRecord);
        this.currentVisualizationDataIndex = 0;
      } else {
        this.genericMapMethodsService.removePreviousActiveAsset();
        this.visualizationAssetIsActive = false;
        if (changeEvent.isUserInput) {
          if (!this.selectedSet || this.selectedSet.length === 0) { 
            // 9/12/26 in Add Asset mode - can't rely on idx from UI when selecting asset class to add - as we are now showing only visible layers. need to look up the correct index in the inventoryLayersData array
            // 10/2/26 are the indexes still tracking now that the data is drawn from eeService.userLayers (with more than just inventory layers)?
            idx = this.eeService.userLayers.filter(l => l.type === "inventory").findIndex(layer => layer.name == this.selectedSet[0].LayerInfo.name);
          }         
          this.eeService.setSelectedLayerIndex(idx);
        } else if (changeEvent.selectedIndex) {
          this.eeService.setSelectedLayerIndex(changeEvent.selectedIndex);
        }
      }
    }
  }
  setThis() {
    return this;
  }
  layerChanged() {
    try {
      /** Selection by Select Tool  */
      if (this.selectedSet?.length > 0) {
        this.selectedLayerName = this.selectedSet[this.eeService.selectedLayerIndex].LayerInfo.name;
        // Manikantha V 2/8/2021
        console.log("layer changed from card view");
        this.selectedCount = this.selectedSet[this.eeService.selectedLayerIndex].Data.length;
        if (this.selectedSet[this.eeService.selectedLayerIndex].LayerInfo.lyrObj?.geometryType === "esriGeometryPolyline") { // visualization layers do not have lyrObj
          this.showreshape = true;
        } else {
          this.showreshape = false;
        }
        this.loadSelectedParentFeatureInView();
      } else {
        if (this.draw) {
          this.draw.deactivate();
        }
        this.loading = false;
        const selectedLayer = this.eeService.userLayers.filter(l => l.type === "inventory")[this.eeService.selectedLayerIndex];
        this.selectedLayerName = selectedLayer.name;
        this.selectedLyrObj = selectedLayer.lyrObj;
        this.selectedLayerInfo = selectedLayer;
        this.currentUser.selectedLayer = this.selectedLayerName;
        this.addNewAsset();
      }
    } catch (error) {
      console.error(error);
    }
  }

  addNewAsset() {
    try {
      // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
      this.eeService.setEnableSingleClick(false);
      const geometryType = this.selectedLyrObj.geometryType;
      let drawType = "";
      if (geometryType === "esriGeometryPoint") {
        drawType = "point";
        this.selectionSymbol = new this.SimpleMarkerSymbol(
          this.SimpleMarkerSymbol.STYLE_DIAMOND,
          12,
          new this.SimpleLineSymbol(this.SimpleLineSymbol.STYLE_NULL, new this.Color([247, 34, 101, 0.9]), 1),
          new this.Color([0, 255, 255, 9])
        );
      } else if (geometryType === "esriGeometryPolyline") {
        drawType = "polyline";
      } else if (geometryType === "esriGeometryPolygon") {
        drawType = "polygon";
      }
      if (!this.draw) this.draw = this.eeService.draw = new this.Draw(this.map);
      this.draw.activate(drawType);

      this.counterVar = 0;
      const mapClick = (this.eeService.mapclick = this.draw.on("draw-end", (evt) => {
        if (this.counterVar == 0) {
          this.counterVar++;
          const wm = this.webMercatorUtils.webMercatorToGeographic(evt.geometry);
          if (this.assetDetailService.isOutsideRegion(evt.geometry, this.geometryEngine, this.currentUser.selectedRegion)) {
            Swal.fire(this.translateService.instant("Select.alertcard.noassetoutregion"));
            mapClick.remove();
            this.draw.deactivate();
            return;
          }
          const asset = new this.Graphic(wm, this.selectionSymbol);
          this.map.graphics.add(asset);
          mapClick.remove();
          if (this.draw) {
            this.draw.deactivate();
          }
          asset.attributes = [];
          // For Model 23/03/2021
          this.showAssetDetail();
          const attr: any = [];
          const promise = this.populateDefaultRegionValues(); // Populating Default Values in New Asset
          promise.then(
            function (regionData: any) {
              regionData.features.forEach((ftr: any) => {
                // let rgn;
                const rgn = this.webMercatorUtils.webMercatorToGeographic(ftr.geometry);
                if (!this.assetDetailService.isOutsideRegion(wm, this.geometryEngine, rgn)) {
                  attr.Region1 = ftr.attributes.RegionName1;
                  attr.Region2 = ftr.attributes.RegionName2;
                  attr.Region3 = ftr.attributes.RegionName3;
                  attr.Region4 = ftr.attributes.RegionName4;
                }
              });
              if (wm.paths) {
                attr.Latitude = wm.paths[0][0][1];
                attr.Longitude = wm.paths[0][0][0];
                attr.Latitude2 = wm.paths[0][wm.paths[0].length - 1][1];
                attr.Longitude2 = wm.paths[0][wm.paths[0].length - 1][0];
              } else {
                attr.Latitude = wm.y;
                attr.Longitude = wm.x;
              }

              attr.Status = "Active";
              attr.Condition = "Good";
              attr.InstallDate = new Date(Date.now()).getTime(); //8/9/20 jcc default install date to now
              attr.ModifiedBy = this.currentUser.username;
              attr.LastModifyDate = new Date(Date.now()).getTime();
              asset.setAttributes(attr);
              this.selectedSet = [];
              this.selectedCount = 1;

              this.currentUser.selectedLayer = this.selectedLayerName;
              this.selectedLyrObj
                .applyEdits([asset], null, null)
                .then((editsResult) => {
                  if (editsResult) {
                    const objectId = editsResult[0].objectId;
                    this.newAssessment(editsResult[0].objectId, this.selectedLayerInfo.name);
                    // AutoGenerate Asset ID
                    const query = new this.Query();
                    query.where = "OBJECTID=" + objectId;
                    const _this = this.setThis();
                    this.selectedLyrObj.refresh();
                    this.selectedLyrObj.clearSelection();
                    this.selectedLyrObj.selectFeatures(query, this.selectedLyrObj.SELECTION_NEW, (res) => {
                      this.map.getLayer("sms-layers").refresh();
                      if (res.length > 0) {
                        this.selectedSet.push({
                          Data: [res[0]],
                          LayerInfo: this.selectedLayerInfo
                        });
                        // _this.saveTask(res);
                        this.showAssetDtl = true;

                        this.generateAssetID(this.selectedSet[0].Data[0], this.selectedLayerName);
                        this.eeService.setSelectedFeaturesOnMap(this.selectedSet);
                      }
                    });
                  }
                })
                .catch((error) => {
                  console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
                });
            }.bind(this)
          );
        }
      }));
    } catch (error) {
      console.error(error);
    }
  }

  newAssessment(newAssetid, layerName) {      //2/21/26  TODO*** remove. If need to create an assessment record, without using the assessment form, should use method in task.service
    try {
      console.log("assetment");
      const features = new this.Graphic();
      const assetAttr: any = [];
      //Jira Id-935
      const prefix = this.assetDetailService.assetFormatCodes.filter((res) => res.attributes.Name === layerName)[0].attributes.LayerCode;
      assetAttr.AssetID = prefix + "_" + newAssetid;
      assetAttr.Condition = "Good";
      assetAttr.Inspector = this.currentUser.displayName;
      assetAttr.InspectionDate = new Date(Date.now()).getTime();
      assetAttr.ModifiedBy = this.currentUser.username;
      assetAttr.LastModifyDate = new Date(Date.now()).getTime();
      features.setAttributes(assetAttr);
      this.assessmentlyr.applyEdits(
        [features],
        null,
        null,
        (evt) => {
          const upfeatures = new this.Graphic();
          const upassetAttr: any = [];
          upassetAttr.OBJECTID = evt[0].objectId;
          upassetAttr.AssessmentID = evt[0].objectId;
          upfeatures.setAttributes(upassetAttr);
          this.assessmentlyr.applyEdits(null, [upfeatures], null);
        },
        (err) => {
          console.log(err);
        }
      );
    } catch (error) {
      console.error(error);
    }
  }

  populateDefaultRegionValues() {
    try {
      const _this = this.setThis();
      return new Promise(function (resolve) {
        const regionLayer = _this.currentUser.webServiceURL + environment.featureServer + _this.currentUser.otherLayerIds.Regions;
        const getRegionData = new _this.Query();
        getRegionData.where = "RegionName" + _this.currentUser.selectedRegion?.regionLevel + "='" + _this.currentUser.selectedRegion?.regionName + "'";
        getRegionData.outFields = ["*"];
        getRegionData.returnGeometry = true;
        const getRegionDataExecute = new _this.QueryTask(regionLayer);
        getRegionDataExecute.execute(getRegionData).then(function (result) {
          resolve(result);
        });
      });
    } catch (error) {
      console.error(error);
    }
  }

  //   /** Gets AssetID prefix from a global Variable and Sets it to Current Asset */
  generateAssetID(asset, layerName) {
    try {
      const attr = asset.attributes;
      //this.asset = asset;

      //Jira Id-935
      const prefix = this.assetDetailService.assetFormatCodes.filter((res) => res.attributes.Name === layerName)[0].attributes.LayerCode;
      attr.AssetID = prefix + "_" + attr.OBJECTID;
      asset.setAttributes(attr);
    } catch (error) {
      console.error(error);
    }
  }

  //   /** Close Card Viewer */
  closeAssetViewer() {
    try {
      if (this.draw) {
        this.draw.deactivate();
      }
      if (this.clickMap) {
        this.clickMap.remove();
      }

      this.eeService.setAssetViewer(false);
    } catch (error) {
      console.error(error);
    }
  }
  showAssetDetail() /** Open Asset Viewer */ {
    this.showAssetDtl = true;
  }

  closeAssetDetail() /** Close Asset Details */ {
    this.showAssetDtl = false;
    this.modalService.dismissAll();
  }
  showRelAssetCard(id, layerName) /** Show Related Assets Accordian in card View */ {  // OBSOLETE? never called
    this.relasstClickedES[id] = !this.relasstClickedES[id];
    this.eeService.toggleCardView(layerName);
  }
  getIfNewAsset() {
    // this.eeService.addNewParent = event;
  }


  buildActiveAssetObject(): any {

    const activeFeature = this.eeService.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex];
    const layerInfo = this.eeService.selectedSet[this.eeService.selectedLayerIndex].LayerInfo;
    const activeAssetObj: any = {
      attributes: activeFeature.attributes,
      layerInfo: layerInfo,
      feature: activeFeature,
      geometry: activeFeature.geometry,
    };

    let region;                                           //smallest region containing active asset. what purpose?
    if (activeFeature.attributes.Region4) {
      region = activeFeature.attributes.Region4;
    } else if (activeFeature.attributes.Region3) {
      region = activeFeature.attributes.Region3;
    } else if (activeFeature.attributes.Region2) {
      region = activeFeature.attributes.Region2;
    } else if (activeFeature.attributes.Region1) {
      region = activeFeature.attributes.Region1;
    }
    activeAssetObj.region = region;

    activeAssetObj.task = 0;                // 7/29/20 jcc -- added this here to maintain expected array positin for task object -- referenced in view.

    const regions = {                                     //jcc 7/26/20 -- capture all regions for current asset
      region1: activeFeature.attributes.Region1,
      region2: activeFeature.attributes.Region2,
      region3: activeFeature.attributes.Region3,
      region4: activeFeature.attributes.Region4
    }; 
    activeAssetObj.regions = regions;

    return activeAssetObj;

  }


  //   /** Creates an Active Asset which opens in the Asset Details Page for related and Primary Assets */
  openAssetDetail(assetType: string, assetData: any, relationshipInfo: IRelationshipInfo) {
    try {
      let assetStatus = false;
      if (assetType === "Child") {
        this.eeService.setSelectedChildAsset(assetData.attributes.AssetID);
        this.eeService.setActiveAssetIsFeature(false);

        if (assetData && assetData.attributes.Status !== "Inactive") {
          assetStatus = true;
        }
        const lyrName = relationshipInfo.name.substring(this.selectedLayerName.length + 2, relationshipInfo.name.length);

        // construct uber Array for child asset
        const selectedChildArray: any[] = [];

        // Add Active Feature Attributes
        selectedChildArray.push(assetData.attributes);

        const lyrObj = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + relationshipInfo.layer_id, { outFields: ["*"] });
        lyrObj.on( "Load", (evt) => {
            this.assetAttributesService.getTableAlias().subscribe((tblresults: any) => {
              tblresults.features.forEach( (f:any) => {
                // const lyrname = element.attributes.Name;
                const tblAliasInfo: ITableAliasesRow = f.attributes;

                if (tblAliasInfo.Name === lyrName) {
                  assetData._layer = lyrObj;
                  const layerObject = assetData._layer;

                  // Add Active Layer object
                  selectedChildArray.push({
                    layerId: lyrObj.layerId,
                    name: lyrName,
                    lyrObj: layerObject,
                    alias: tblAliasInfo.Alias,
                    idPrefix: tblAliasInfo.LayerCode,
                    aliasSL: tblAliasInfo.Alias_SL
                  } as ILayer);

                  // duplicate need to delete
                  selectedChildArray.push(assetData);

                  // Add Active Asset geometry -- if it is child element then add parent geom
                  selectedChildArray.push({
                    geometry: this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].geometry
                  });

                  // Add Active Region -- if it is child element then add parent region
                  let region;
                  if (this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region4) {
                    region = this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region4;
                  } else if (this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region3) {
                    region = this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region3;
                  } else if (this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region2) {
                    region = this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region2;
                  } else if (this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region1) {
                    region = this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region1;
                  }
                  selectedChildArray.push({ region });

                  //7/28/20 - get all regions for child asset
                  const regions = {
                    region1: this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region1,
                    region2: this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region2,
                    region3: this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region3,
                    region4: this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.Region4
                  };

                  // Add all regions
                  selectedChildArray.push({ regions: regions });

                  this.activeAsset = selectedChildArray;                 
                  // 9/13/26 these non-existent properties of this were allowed to be added when this callback was explicitly bound to this with .bind(this), Seems like dead code that is no longer relevant
                  //this.activeChildAsset = selectedChildFeature;
                  //this.activeObjectId = selectedChildFeature[0].OBJECTID;
                  this.activeAssetId = selectedChildArray[0].AssetID; //jcc 9/22/20
                  //this.IsOpenAssetDetail = true;
                  this.eeService.setActiveAsset(selectedChildArray);
                  //this.IsOpenAssetDetail = false;
                  // if (this.assetDetails) {
                  //   this.assetDetails.initAssetDetail();
                  // }
                }
              });
            });
          }
        );
      } else if (assetType === "Parent") {
        if (this.activeFeature[0].Status !== "Inactive") {
          this.eeService.setSelectedChildAsset(null);
          this.eeService.setActiveAssetIsFeature(true);
          this.eeService.setActiveAsset(this.activeFeature);
          this.activeAssetId = this.activeFeature[0].AssetID;
          assetStatus = true;
        }
      }

      if (this.activeFeature[0].Status !== "Inactive") {
        if (assetStatus) {
          this.showAssetDetail();
        } else {
          this.closeAssetDetail();
        }
      } else {
        this.closeAssetDetail();
      }
    } catch (error) {
      console.error(error);
    }
  }

  // //   /** Get Asset Attributes after saving in Asset Details Page */
  // getAssetAttributes() {
  //   // this.attribs = event;
  // }

  addRelatedAsset(relatedAssetName: string) {
    try {
      // this.isAssetNew = true;
      this.relatedAssetToAdd = relatedAssetName;
      let relatedLayerurl: any;
      this.eeService.addNewChild = true;
      if (relatedAssetName === "Light") {
        //  this.layerName = this.selectRelAsset;
        relatedLayerurl = this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.lightId;
      }
      if (relatedAssetName === "Sign") {
        //  this.layerName = this.selectRelAsset;
        relatedLayerurl = this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.signId;
      }

      // For Model 23/03/2021
      this.showAssetDetail();
      const featureLayer = new this.FeatureLayer(relatedLayerurl);
      const geometry = this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].geometry;
      const newChildAsset = new this.Graphic(geometry);
      const assetAttr: any = [];
      newChildAsset.setAttributes(assetAttr);

      //Jira Id-935
      const prefix = this.assetDetailService.assetFormatCodes.filter((res) => res.attributes.Name === relatedAssetName)[0].attributes.LayerCode;

      assetAttr.ParentID = this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.AssetID;
      assetAttr.Status = "Active";
      assetAttr.InstallDate = new Date(Date.now()).getTime(); //8/9/20 jcc default install date to now          doesn't flow through from here
      assetAttr.Condition = "Good"; //8/11/20 jcc default new child asset to Good condition
      assetAttr.ModifiedBy = this.currentUser.username;
      assetAttr.LastModifyDate = new Date(Date.now()).getTime();
      newChildAsset.setAttributes(assetAttr);
      newChildAsset.geometry = null;
      newChildAsset._layer = featureLayer;
      featureLayer.applyEdits([newChildAsset], null, null).then(
        (newchild) => {
          const featurese = [];
          const features = new this.Graphic();
          const assetId = prefix + "_" + newchild[0].objectId;
          this.newChildId = newchild[0].objectId;
          features.setAttributes({
            OBJECTID: newchild[0].objectId,
            AssetID: assetId,
            ParentID: this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.AssetID
          });
          const featTest = features;
          // features.setAttributes(attributes)
          featurese.push(features);
          this.eeService.setSelectedChildAsset(assetId);
          this.eeService.setActiveAssetIsFeature(false);
          featureLayer
            .applyEdits(null, featurese, null)
            .then(
              () => {
                this.newChildFeature = featTest;
                this.newChildFClass = featureLayer.name;
                // this.saveTask(featTest, featureLayer.name);
                this.loadSelectedParentFeatureInView();
                this.assetDetailService.tasksModified.emit(true);
              }
            )
            .catch((error) => {
              console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
              console.log("error = ", error);
            });
          this.newAssessment(newchild[0].objectId, this.relatedAssetToAdd);
        }
      );
    } catch (error) {
      console.error(error);
    }
  }
  selectChildAndOpenAtt() {
    try {
      if (this.eeService.addNewParent && this.newChildId) {
        const relatedFeatures = this.childRelationshipInfo.find( (r) => r.name.includes(this.relatedAssetToAdd) );
        if (relatedFeatures?.data?.length > 0) {
          const relatedFeature = relatedFeatures.data.find( (d: any) => d.attributes.OBJECTID === this.newChildId );
          this.openAssetDetail("Child", relatedFeature, relatedFeatures);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  //   /** Set images for primary and related assets */
  setSignPic(event, relatedFeature) {
    try {
      event.target.src = "assets/images/nopic.png";
      this.renderer.listen(event.target, "error", this.onPicError);
    } catch (error) {
      console.error(error);
    }
  }
  onPicError(event) {
    event.target.src = "assets/images/nopic.png";
  }

  relocateAsset() {
    // Mani for disableing single click on map
    this.eeService.setEnableSingleClick(false);
    this.SaveExistData();
    this.eeService.disablebutton();
    this.EnableIcon(false); //TSDRSAM-1869
    // TSDRSAM-1099 By Manikantha V
    if (this.eeService.activeAssetInfo[0].AssetID.includes("SIG") || this.eeService.activeAssetInfo[0].AssetID.includes("LGT")) {
      this.eeService.setEnableSingleClick(true);
      this.relocateChildAsset(this.eeService.activeAssetInfo[2]);
    } else {
      this.relocateAssetBasedOnGeom(this.eeService.activeAssetInfo[2], this.eeService.activeAssetInfo[1].lyrObj, this.eeService.activeAssetInfo[1].lyrObj.geometryType);
    }
  }
  // JIRA ID:1099 By Manikantha V
  relocateChildAsset(relatedFeature) {
    // update ParentID of active child asset to AssetID of the Support user clicks on the map
    this.SaveExistData();
    this.eeService.disablebutton();
    this.genericMapMethodsService.relocateChildAsset = relatedFeature;
    this.genericMapMethodsService.esriBundle.toolbars.draw.addPoint = "Click to move to new parent asset.";
    this.draw = this.Draw(this.map);
    this.draw.activate("point");

    //this.draw.activate("point");
    this.genericMapMethodsService.relocateChild = true;
    this.clickMap = this.draw.on(
      "draw-end",
      function (evt) {
        this.genericMapMethodsService.esriBundle.toolbars.draw.addPoint = "Click to add a point";
        this.draw.deactivate();
        this.eeService.enablebutton();
        this.EnableIcon(true); //TSDRSAM-1869
      }.bind(this)
    );
  }

  relocateAssetBasedOnGeom(selectedAsset, featureLayer, geometryType) {
    // TSDRSAM-1070 By Manikantha V
    // relocate spatial asset to new location user clicks on the map
    let graphic = new this.Graphic();
    graphic = selectedAsset;
    const old_geom = graphic.geometry;

    if (geometryType === "esriGeometryPolyline" || geometryType === "esriGeometryPolygon") {
      this.map.disableDoubleClickZoom(true);
      const edit = new this.Edit(this.map, {
        ghostLineSymbol: new this.SimpleLineSymbol(this.SimpleLineSymbol.STYLE_DASH, new this.Color([0, 0, 255]))
      });
      const lineSymbol = new this.SimpleLineSymbol({ color: new this.Color([0, 0, 255, 1]), type: "simplelinesymbol" });
      graphic.setSymbol(new this.SimpleLineSymbol(lineSymbol).setWidth(this.genericMapMethodsService.linearAssetRelocateWidth));
      this.map.graphics.add(graphic);
      edit.activate(this.Edit.MOVE, graphic);
      this.clickMap = this.map.on(
        "dbl-click",
        function (evt) {
          this.eeService.enablebutton();
          this.EnableIcon(true);
          this.map.enableDoubleClickZoom(true);
          if (this.eeService.selectedSet.length == 1 && this.eeService.selectedSet[0].Data.length == 1) {
            this.eeService.setEnableSingleClick(true);
          }
          this.populateRegionGeometry().then((results) => {
            let isAssetinAnyRegion = true;
            if (this.assetDetailService.isOutsideRegion(graphic.geometry, this.geometryEngine, this.currentUser.selectedRegion)) {
              isAssetinAnyRegion = false;
              console.log("isOutsideRegion + " + isAssetinAnyRegion);
            } else {
              isAssetinAnyRegion = true;
              this.assetPlacedinRegion = this.currentUser.selectedRegion;
              console.log("isOutsideRegion + " + isAssetinAnyRegion);
            }
            if (isAssetinAnyRegion) {
              Swal.fire({
                title: this.translateService.instant("Select.alertcarddisplay.relocateasset"),
                text: this.translateService.instant("Select.alertcarddisplay.confirmrelocateasset"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.translateService.instant("Select.alertcarddisplay.savebtn")
              }).then((result) => {
                if (result.value) {
                  this.populateChangedAssetDefaultValues(this.assetPlacedinRegion, graphic, this.Query, this.QueryTask).then(
                    function (result) {
                      featureLayer.applyEdits(null, [result], null).then(
                        function (res) {
                          this.updateLatLong(result);
                          this.queryLayersService.updateAsset(featureLayer, result).then(
                            function (res) {
                              this.refreshAfterEdit(result);
                              edit.deactivate();
                              this.createRelocateTask(result, old_geom);
                            }.bind(this)
                          );
                        }.bind(this)
                      );
                    }.bind(this)
                  );
                } else {
                  //graphic.geometry = old_geom;
                  if (this.map.getLayer("sms-layers")) this.map.getLayer("sms-layers").refresh();
                  this.map.graphics.remove(
                    this.map.graphics.graphics.filter((item) => {
                      // TSDRSAM-975 By Manikantha V
                      if (item.symbol.width == this.genericMapMethodsService.linearAssetRelocateWidth) {
                        return item;
                      }
                    })[0]
                  );
                  this.genericLayerService.getFilteredFeaturesByFieldWithGeom(featureLayer.layerId, "AssetID", graphic.attributes.AssetID).subscribe(
                    function (feature) {
                      console.log(feature);
                      this.eeService.activeAssetInfo[2].geometry.paths = feature.features[0].geometry.paths;
                      // TSDRSAM-975 By Manikantha V
                      this.refreshAfterEdit(feature.features[0], old_geom);
                    }.bind(this)
                  );

                  this.clickMap.remove();
                }
              });
              this.clickMap.remove();
              edit.deactivate();
            } else {
              Swal.fire(this.translateService.instant("Select.newasset.outside"));
              if (this.map.getLayer("sms-layers")) this.map.getLayer("sms-layers").refresh();
              this.map.graphics.remove(
                this.map.graphics.graphics.filter((item) => {
                  if (item.symbol.width == this.genericMapMethodsService.linearAssetRelocateWidth) {
                    return item;
                  }
                })[0]
              );

              // this.map.graphics.graphics.filter((item) => { console.log(item.symbol.style);console.log(item.graphictype) })
              this.genericLayerService.getFilteredFeaturesByFieldWithGeom(featureLayer.layerId, "AssetID", graphic.attributes.AssetID).subscribe(
                function (feature) {
                  this.eeService.activeAssetInfo[2].geometry.paths = feature.features[0].geometry.paths;
                  this.refreshAfterEdit(feature.features[0]);
                }.bind(this)
              );
              edit.deactivate();
              this.clickMap.remove();

              this.refreshAfterEdit();
              return;
            }
          });
        }.bind(this)
      );
    } else if (geometryType === "esriGeometryPoint") {
      this.draw = this.Draw(this.map);
      this.draw.activate("point");
      let isAssetinAnyRegion = false;
      this.clickMap = this.draw.on(
        "draw-end",
        function (evt) {
          this.eeService.enablebutton();
          this.EnableIcon(true);
          if (this.eeService.selectedSet.length == 1 && this.eeService.selectedSet[0].Data.length == 1) {
            this.eeService.setEnableSingleClick(true);
          }
          this.populateRegionGeometry().then((results) => {
            //  for (let i = 0; i < results.length; i++) {
            if (this.assetDetailService.isOutsideRegion(evt.geometry, this.geometryEngine, this.currentUser.selectedRegion)) {
              isAssetinAnyRegion = false;
            } else {
              isAssetinAnyRegion = true;
              this.assetPlacedinRegion = this.currentUser.selectedRegion;
              // break;
            }
            // }
            if (isAssetinAnyRegion) {
              let destination = new this.Graphic();
              const final_asset = [];
              Swal.fire({
                title: this.translateService.instant("Select.alertcarddisplay.relocateasset"),
                text: this.translateService.instant("Select.alertcarddisplay.confirmrelocateasset"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.translateService.instant("Select.alertcarddisplay.savebtn")
              })
                .then((result) => {
                  if (result.value) {
                    destination = selectedAsset;
                    destination.geometry = evt.geometry;
                    this.populateChangedAssetDefaultValues(this.assetPlacedinRegion, destination, this.Query, this.QueryTask).then(
                      function (result) {
                        final_asset.push(result);
                        featureLayer.applyEdits(null, [result], null).then(
                          function (res) {
                            this.updateLatLong(result);
                            this.queryLayersService.updateAsset(featureLayer, result).then(
                              function (res) {
                                this.refreshAfterEdit(result);
                                if (this.draw) {
                                  this.draw.deactivate();
                                }
                                this.createRelocateTask(result, old_geom);
                              }.bind(this)
                            );
                          }.bind(this)
                        );
                      }.bind(this)
                    );
                  }
                })
                .catch((error) => {
                  console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
                });
              this.clickMap.remove();
              if (this.draw) {
                this.draw.deactivate();
              }
            } else {
              Swal.fire(this.translateService.instant("Select.newasset.outside"));
              this.refreshAfterEdit(selectedAsset);
              if (this.draw) {
                this.draw.deactivate();
              }
              return;
            }
          });
        }.bind(this)
      );
    }
  }
  reshape() {
    // modify vertices of polyline assets per user map clicks
    this.eeService.disablebutton();
    //TSDRSAM-1869
    this.EnableIcon(false);
    this.SaveExistData();
    this.map.disableDoubleClickZoom(true);
    // Mani
    this.eeService.setEnableSingleClick(false);
    const editToolbar = new this.Edit(this.map, { showTooltips: true });
    const tool = this.Edit.EDIT_VERTICES; // Tool for Editing Vertices

    editToolbar.on(
      "vertex-move-stop",
      function (evt) {
        this.map.graphics.remove(evt.graphic);
        this.map.graphics.remove(
          this.map.graphics.graphics.filter((item) => {
            if (item.graphictype == "dotline") {
              return item;
            }
          })[0]
        );
        const lineSymbolShortDot = new this.SimpleLineSymbol(this.SimpleLineSymbol.STYLE_SHORTDOT, "black", 2);
        const newGraphic = new this.Graphic(evt.graphic.geometry, lineSymbolShortDot);
        newGraphic.graphictype = "dotline";
        this.map.graphics.add(newGraphic);
        this.map.graphics.refresh();
        editToolbar.activate(tool, evt.graphic);
      }.bind(this)
    );

    let graphic = this.eeService.activeAssetInfo[2];
    graphic.symbol = null;
    this.map.graphics.add(graphic);
    const old_geom = graphic.geometry;
    const current_asset_location = editToolbar.getCurrentState();
    current_asset_location.graphic = graphic;
    const featureLayerTemp = this.eeService.activeAssetInfo[1].lyrObj;
    if (featureLayerTemp.geometryType === "esriGeometryPoint") {
      Swal.fire(this.translateService.instant("Select.alertcarddisplay.cannotbereshaped"));
    } else {
      editToolbar.activate(tool, graphic);
      this.clickMap = this.map.on(
        "dbl-click",
        function () {
          this.eeService.enablebutton();
          this.EnableIcon(true); //TSDRSAM-1869
          if (this.eeService.selectedSet.length == 1 && this.eeService.selectedSet[0].Data.length == 1) {
            this.eeService.setEnableSingleClick(true);
          }
          if (this.assetDetailService.isOutsideRegion(graphic.geometry, this.geometryEngine, this.currentUser.selectedRegion)) {
            this.populateRegionGeometry().then(
              function (results) {
                let isAssetinAnyRegion = false;
                for (let i = 0; i < results.length; i++) {
                  if (this.assetDetailService.isOutsideRegion(graphic.geometry, this.geometryEngine, results[i])) {
                    isAssetinAnyRegion = false;
                  } else {
                    isAssetinAnyRegion = true;
                    this.assetPlacedinRegion = results[i];
                    break;
                  }
                }
                if (isAssetinAnyRegion) {
                  this.map.enableDoubleClickZoom(true);
                  this.clickMap.remove();
                  editToolbar.deactivate();
                  editToolbar.refresh();

                  this.map.graphics.remove(
                    this.map.graphics.graphics.filter((item) => {
                      if (item.graphictype == "dotline") {
                        return item;
                      }
                    })[0]
                  );
                  this.genericLayerService.getFilteredFeaturesByFieldWithGeom(featureLayerTemp.layerId, "AssetID", graphic.attributes.AssetID).subscribe(
                    function (feature) {
                      this.eeService.activeAssetInfo[2].geometry.paths = feature.features[0].geometry.paths;
                      this.refreshAfterEdit(feature.features[0]);
                    }.bind(this)
                  );
                  this.map.graphics.refresh();
                } else {
                  this.genericLayerService.getFilteredFeaturesByFieldWithGeom(featureLayerTemp.layerId, "AssetID", graphic.attributes.AssetID).subscribe(
                    function (feature) {
                      this.eeService.activeAssetInfo[2].geometry.paths = feature.features[0].geometry.paths;
                    }.bind(this)
                  );
                  if (this.assetDetailService.crossesPolygon(graphic.geometry, this.geometryEngine, this.currentUser.selectedRegion)) {
                    Swal.fire(this.translateService.instant("Select.newasset.differentregion"));
                  } else {
                    Swal.fire(this.translateService.instant("Select.newasset.outside"));
                  }
                  this.map.enableDoubleClickZoom(true);
                  this.clickMap.remove();
                  editToolbar.deactivate();
                  editToolbar.refresh();

                  this.map.graphics.remove(
                    this.map.graphics.graphics.filter((item) => {
                      if (item.graphictype == "dotline") {
                        return item;
                      }
                    })[0]
                  );
                  this.genericLayerService.getFilteredFeaturesByFieldWithGeom(featureLayerTemp.layerId, "AssetID", graphic.attributes.AssetID).subscribe(
                    function (feature) {
                      this.eeService.activeAssetInfo[2].geometry.paths = feature.features[0].geometry.paths;
                      this.refreshAfterEdit(feature.features[0]);
                    }.bind(this)
                  );
                  this.map.graphics.refresh();
                  return;
                }
              }.bind(this)
            );
          } else {
            Swal.fire({
              title: this.translateService.instant("Select.alertcarddisplay.reshapeasset"),
              text: this.translateService.instant("Select.alertcarddisplay.confirmreshapeasset"),
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: this.translateService.instant("Select.alertcarddisplay.savebtn")
            }).then(
              function (result) {
                if (result.value) {
                  graphic = this.updateLatLong(graphic);

                  this.queryLayersService.updateAsset(featureLayerTemp, graphic).then(
                    function () {
                      this.map.enableDoubleClickZoom(true);
                      this.clickMap.remove();
                      editToolbar.deactivate();
                      editToolbar.refresh();
                      this.createReshapeTask(graphic, old_geom);
                      this.refreshAfterEdit(graphic);
                      // this.map.graphics.remove(this.map.graphics.graphics.filter((item) => { if (item.graphictype == "dotline") { return item } })[0]);
                      this.map.graphics.refresh();
                    }.bind(this)
                  );
                } else {
                  this.map.enableDoubleClickZoom(true);
                  this.clickMap.remove();
                  editToolbar.deactivate();
                  editToolbar.refresh();

                  this.map.graphics.remove(
                    this.map.graphics.graphics.filter((item) => {
                      if (item.graphictype == "dotline") {
                        return item;
                      }
                    })[0]
                  );
                  this.map.graphics.graphics.filter((item) => {
                    if (item.attributes && item.symbol && item.symbol.width == 4) return item;
                  })[0] = old_geom;
                  this.genericLayerService.getFilteredFeaturesByFieldWithGeom(featureLayerTemp.layerId, "AssetID", graphic.attributes.AssetID).subscribe(
                    function (feature) {
                      this.eeService.activeAssetInfo[2].geometry.paths = feature.features[0].geometry.paths;
                      this.refreshAfterEdit(feature.features[0]);
                    }.bind(this)
                  );
                  this.map.graphics.refresh();
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    }
  }
  refreshAfterEdit(modifiedAsset?, old_geom?): void {
    this.refreshFeatures(modifiedAsset, old_geom);
    // if (this.map.getLayer("sms-layers")) {
    //   this.map.getLayer("sms-layers").refresh();
    // }

    // if (this.map.getLayer("sms-selection")) {
    //   this.map.getLayer("sms-selection").refresh();
    // }

    // this.map.graphics.refresh();
    // this.map.enableMapNavigation();

    // if (modifiedAsset && modifiedAsset.geometry) {
    //   const countFea = this.map.getLayer("sms-selection").graphics.filter((item) => {
    //     if (item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item;
    //   }).length;
    // }
    // if (modifiedAsset && modifiedAsset.geometry &&
    //    this.map.getLayer("sms-selection").graphics
    //    .filter((item)=>{if(item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item}).length>0) {
    //   if (this.map.getLayer("sms-selection")){
    //     const wm = this.webMercatorUtils.webMercatorToGeographic(modifiedAsset.geometry);
    //     if ((wm && wm.paths) || modifiedAsset.geometry.paths) {
    //       for(let i=0;i<this.map.getLayer("sms-selection").graphics.filter((item)=>{if( item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item}).length;i++){
    //       if(this.map.getLayer("sms-selection").graphics.filter((item)=>{if( item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item})[i].geometry.paths){
    //         this.map.getLayer("sms-selection").graphics.filter((item)=>{if( item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item})[i].geometry = modifiedAsset.geometry;
    //       }
    //       // else{
    //       //   this.map.getLayer("sms-selection").graphics.filter((item)=>{if( item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item})[i].geometry = this.getPolylineMidPoint(modifiedAsset.geometry);
    //       // }

    //       }

    //     }
    //     else {
    //       this.map.getLayer("sms-selection").graphics.filter((item)=>{if( item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item})[0].geometry = this.getPolylineMidPoint(modifiedAsset.geometry);
    //      }
    //   }
    //   for(let j=0;j<this.map.graphics.graphics.filter((item)=>{if( item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item}).length;j++){
    //     if(this.map.graphics.graphics.filter((item)=>{if( item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item})[j].geometry.paths){
    //       this.map.graphics.graphics.filter((item)=>{if( item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item})[j].geometry = modifiedAsset.geometry;
    //     }
    //     else{
    //       this.map.getLayer("sms-selection").graphics.filter((item)=>{if( item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item})[j].geometry = modifiedAsset.geometry;
    //     }

    //     }
    // }
  }
  refreshFeatures(modifiedAsset?, old_geom?): void {
    let geometryAsset = modifiedAsset.geometry;
    if (!geometryAsset.spatialReference && old_geom && old_geom.spatialReference) {
      geometryAsset = old_geom;
    }
    const smsSelectionFeatures = this.map.getLayer("sms-selection").graphics.filter((item) => {
      if (item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item;
    });
    if (modifiedAsset && modifiedAsset.geometry) {
      if (smsSelectionFeatures.length) {
        for (let i = 0; i < smsSelectionFeatures.length; i++) {
          const selAsset = this.map.getLayer("sms-selection").graphics.filter((item) => {
            if (item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item;
          })[i];
          if (selAsset && selAsset.geometry.paths) {
            this.map.getLayer("sms-selection").graphics.filter((item) => {
              if (item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item;
            })[i].geometry = geometryAsset;
          } else {
            if (modifiedAsset.geometry.paths) {
              this.map.getLayer("sms-selection").graphics.filter((item) => {
                if (item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item;
              })[i].geometry = this.genericMapMethodsService.getPolylineMidPoint(geometryAsset);
            } else {
              this.map.getLayer("sms-selection").graphics.filter((item) => {
                if (item.attributes && item.attributes.AssetID == modifiedAsset.attributes.AssetID) return item;
              })[i].geometry = geometryAsset;
            }
          }
        }
      }
    }

    if (this.map.getLayer("sms-layers")) {
      this.map.getLayer("sms-layers").refresh();
    }
    if (this.map.getLayer("sms-selection")) {
      this.map.getLayer("sms-selection").refresh();
    }
    this.map.graphics.refresh();
    this.map.enableMapNavigation();
  }
  updateLatLong(graphic) {
    const wm = this.webMercatorUtils.webMercatorToGeographic(graphic.geometry);
    if (wm.paths) {
      graphic.attributes.Latitude = wm.paths[0][0][1];
      graphic.attributes.Longitude = wm.paths[0][0][0];
      graphic.attributes.Latitude2 = wm.paths[0][wm.paths[0].length - 1][1];
      graphic.attributes.Longitude2 = wm.paths[0][wm.paths[0].length - 1][0];
    } else {
      // TSDRSAM-975 By Manikantha V
      graphic.attributes.Latitude = wm.y;
      graphic.attributes.Longitude = wm.x;
    }
    return graphic;
  }
  populateRegionGeometry() {
    return new Promise((resolve) => {
      const rdata = [];
      const tempRegion = this.map.smsRegiondata;
      const fl = this.currentUser.webServiceURL + environment.featureServer + this.currentUser.otherLayerIds.Regions;
      tempRegion.forEach((region) => {
        const regionObj = region;
        const query = new this.Query();
        const qtask = new this.QueryTask(fl);
        query.where = "RegionName" + regionObj.regionLevel + "='" + regionObj.regionName + "'";
        query.returnGeometry = true;
        qtask.execute(query).then((evt) => {
          if (evt.features.length === 1) {
            const poly = new this.Polygon(evt.features[0].geometry);
            regionObj.Extent = poly.getExtent();
            regionObj.geom = poly;
            rdata.push(regionObj);
          } else {
            const subRegionsList = [];
            for (let i = 0; i < evt.features.length; i++) {
              subRegionsList.push(evt.features[i].geometry);
            }
            const geom_union = this.geometryEngine.union(subRegionsList);
            const poly = new this.Polygon(geom_union);
            regionObj.Extent = poly.getExtent();
            regionObj.geom = poly;
            rdata.push(regionObj);
          }
          if (rdata.length === this.map.smsRegiondata.length) {
            resolve(rdata);
          }
        });
      });
    });
  }
  populateChangedAssetDefaultValues(placedinRegion, asset) {
    return new Promise(
      function (resolve) {
        const promise = this.assetDetailService.populateDefaultRegionValues(this.currentUser, placedinRegion, this.Query, this.QueryTask);
        promise.then((result) => {
          // let regionData: any;
          const regionData = result;
          const attrib = asset.attributes;
          regionData.features.forEach((ftr) => {
            // let rgn, geom;
            const rgn = this.webMercatorUtils.webMercatorToGeographic(ftr.geometry);
            const geom = this.webMercatorUtils.webMercatorToGeographic(asset.geometry);
            if (!this.assetDetailService.isOutsideRegion(geom, this.geometryEngine, rgn)) {
              attrib.Region1 = ftr.attributes.RegionName1;
              attrib.Region2 = ftr.attributes.RegionName2;
              attrib.Region3 = ftr.attributes.RegionName3;
              attrib.Region4 = ftr.attributes.RegionName4;
            }
          });
          asset.setAttributes(attrib);
          resolve(asset);
        });
      }.bind(this)
    );
  }
  XXXsaveTask(asset, featureClassName?) { /// is this obsolete????  see version in asset-detail.component.ts
    this.ftrLyrTblMaintenance = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.maintenanceId, { outFields: ["*"] });
    this.ftrLyrActivity = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.activityId, { outFields: ["*"] });
    if (this.selectedLayerName != "") {
      this.ftrLyrActivity.on(
        "Load",
        function (evt) {
          this.getLayerId(evt.layer.types, this.selectedLayerName);
        }.bind(this)
      );
    } else {
      this.ftrLyrActivity.on(
        "Load",
        function (evt) {
          this.getLayerId(evt.layer.types, this.selectRelAsset);
        }.bind(this)
      );
    }
    const featurese = [];
    const features = new this.Graphic();
    // this.asset = asset;
    let assetId;
    if (asset.attributes && asset.attributes.AssetID) {
      assetId = asset.attributes.AssetID;
    } else {
      //Jira Id-935
      const prefix = this.assetDetailService.assetFormatCodes.filter((res) => res.attributes.Name === this.selectedLayerName)[0].attributes.LayerCode;
      assetId = prefix + "_" + asset[0].attributes.OBJECTID;
    }

    let geomString;

    if (asset[0] && asset[0].geometry) {
      geomString = asset[0].geometry.toJson();
    } else {
      geomString = this.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].geometry.toJson();
    }
    if (geomString.paths) {
      geomString.x = geomString.paths[0][0][0];
      geomString.y = geomString.paths[0][0][1];
      delete geomString.paths;
    }
    let region;
    if (asset[0] && asset[0].attributes) {
      if (asset[0].attributes.Region4) {
        region = asset[0].attributes.Region4;
      } else if (asset[0].attributes.Region3) {
        region = asset[0].attributes.Region3;
      } else if (asset[0].attributes.Region2) {
        region = asset[0].attributes.Region2;
      } else if (asset[0].attributes.Region1) {
        region = asset[0].attributes.Region1;
      } else if (asset[4].attributes.region) {
        region = asset[4].attributes.region;
      }
    } else {
      region = null;
    }

    if (!region) {
      if (this.activeFeature[0]) {
        if (this.activeFeature[0].Region4) {
          region = this.activeFeature[0].Region4;
        } else if (this.activeFeature[0].Region3) {
          region = this.activeFeature[0].Region3;
        } else if (this.activeFeature[0].Region2) {
          region = this.activeFeature[0].Region2;
        } else if (this.activeFeature[0].Region1) {
          region = this.activeFeature[0].Region1;
        } else if (this.activeFeature[0].region) {
          region = this.activeFeature[0].region;
        }
      }
    }
    let status;
    if (this.dataEditorSettings?.taskType === "New") {
      status = "Open";
    } else {
      status = "Closed";
    }
    let assetName;
    if (featureClassName) {
      assetName = featureClassName;
    } else {
      assetName = this.selectedLayerName;
    }
    features.setAttributes({
      Status: status,
      CreatedBy: this.currentUser.username,
      CreationDate: new Date(Date.now()).getTime(),
      Region: region,
      AssetID: assetId,
      AssetName: assetName,
      WorkOrderDesc: "",
      Comment: "",
      GeomWKT: JSON.stringify(geomString),
      ModifiedBy: this.currentUser.username,
      LastModifyDate: new Date(Date.now()).getTime()
    });
    featurese.push(features);

    this.ftrLyrTblMaintenance
      .applyEdits(featurese, null, null)
      .then(
        function (newrow) {
          // updateing MaintID for newly inserted Maintanance record
          const featureseAssetID = [];
          const featuresA = new this.Graphic();
          featuresA.setAttributes({ OBJECTID: newrow[0].objectId, MaintID: "MNT_" + newrow[0].objectId });
          featureseAssetID.push(featuresA);
          // TSDRSAM-1304 Manikantha V
          this.ftrLyrTblMaintenance
            .applyEdits(null, featureseAssetID, null)
            .then(
              function () {
                console.log("updated");
              }.bind(this)
            )
            .catch((error) => {
              console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
            });
          // End
          const actfeaturese = [];
          const actfeatures = new this.Graphic();
          actfeatures.setAttributes({
            MaintID: "MNT_" + newrow[0].objectId,
            Asset: this.assetTypeId,
            Activity: this.dataEditorSettings?.taskType || "New",         // is this either Collect or New??
            Description: " ",
            ModifiedBy: this.currentUser.username,
            LastModifyDate: new Date(Date.now()).getTime()
          });
          actfeaturese.push(actfeatures);
          this.ftrLyrActivity.applyEdits(actfeaturese, null, null);
          if (this.wrkStatus === "Closed" && (this.activity === "Replace" || this.activity === "Retire")) {
            features.attributes.OBJECTID = newrow[0].objectId;
            this.task.completeTask(features.attributes);
          }
        }.bind(this)
      )
      .catch(function (error) {
        console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
      });
  }
  getLayerId(data, layer_name) {
    this.assetTypeId = data.filter(
      function (hero) {
        return hero.name === layer_name;
      }.bind(this)
    )[0].id;
  }
  createRelocateTask(asset, old_geom) {
    console.log(old_geom);
    this.ftrLyrTblMaintenance = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.maintenanceId, { outFields: ["*"] });
    this.ftrLyrActivity = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.activityId, { outFields: ["*"] });
    const featurese = [];
    const features = new this.Graphic();
    const assetId = asset.attributes.AssetID;
    const geomString = asset.geometry.toJson();
    if (geomString.paths) {
      geomString.x = geomString.paths[0][0][0];
      geomString.y = geomString.paths[0][0][1];
      delete geomString.paths;
    }
    let region;
    if (asset.attributes.Region4) {
      region = asset.attributes.Region4;
    } else if (asset.attributes.Region3) {
      region = asset.attributes.Region3;
    } else if (asset.attributes.Region2) {
      region = asset.attributes.Region2;
    } else if (asset.attributes.region) {
      region = asset.attributes.region;
    }
    const status = "Closed";
    // TSDRSAM-1114 By Manikantha V
    features.setAttributes({
      Status: status,
      CreatedBy: this.currentUser.username,
      CreationDate: new Date(Date.now()).getTime(),
      CompletedBy: this.currentUser.username,
      CompletionDate: new Date(Date.now()).getTime(),
      Region: region,
      Reason: "Other",
      AssetID: assetId,
      AssetName: this.selectedLayerName,
      WorkOrderDesc: "",
      Comment: "",
      GeomWKT: JSON.stringify(geomString),
      PendingChanges: JSON.stringify(this.generatePendingChangesForGeometryChange(this.rollbackData.Shape, asset.geometry)),
      ModifiedBy: this.currentUser.username,
      LastModifyDate: new Date(Date.now()).getTime()
    });
    featurese.push(features);
    this.ftrLyrTblMaintenance
      .applyEdits(featurese, null, null)
      .then(
        function (newrow) {
          const featureseAssetID = [];
          const featuresA = new this.Graphic();
          featuresA.setAttributes({ OBJECTID: newrow[0].objectId, MaintID: "MNT_" + newrow[0].objectId });
          featureseAssetID.push(featuresA);
          //TSDRSAM-1304 Manikantha V
          //TSDRSAM-1580 added by Harshal,code fix for TSDRSAM-1304 merged to Dev branch
          this.ftrLyrTblMaintenance
            .applyEdits(null, featureseAssetID, null)
            .then(
              function () {
                console.log("updated");
              }.bind(this)
            )
            .catch((error) => {
              console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
            });
          // End
          const actfeaturese = [];
          const actfeatures = new this.Graphic();
          actfeatures.setAttributes({
            MaintID: "MNT_" + newrow[0].objectId,
            Asset: this.assetTypeId,
            Activity: "Relocate",
            Description: " ",
            ModifiedBy: this.currentUser.username,
            LastModifyDate: new Date(Date.now()).getTime()
          });
          actfeaturese.push(actfeatures);
          this.ftrLyrActivity.applyEdits(actfeaturese, null, null).then(
            function () {
              this.eeService.setreplaceTaskCreated(true);
            }.bind(this)
          );
          this.assetDetailService.assetChanged.emit(this.activeFeature);
        }.bind(this)
      )
      .catch((error) => {
        console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
      });
  }
  createReshapeTask(asset, old_geom) {
    console.log(old_geom);
    this.ftrLyrTblMaintenance = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.maintenanceId, { outFields: ["*"] });
    this.ftrLyrActivity = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.activityId, { outFields: ["*"] });
    const featurese = [];
    const features = new this.Graphic();
    const assetId = asset.attributes.AssetID;
    const geomString = asset.geometry.toJson();
    if (geomString.paths) {
      geomString.x = geomString.paths[0][0][0];
      geomString.y = geomString.paths[0][0][1];
      delete geomString.paths;
    }
    let region;
    if (asset.attributes.Region4) {
      region = asset.attributes.Region4;
    } else if (asset.attributes.Region3) {
      region = asset.attributes.Region3;
    } else if (asset.attributes.Region2) {
      region = asset.attributes.Region2;
    } else if (asset.attributes.region) {
      region = asset.attributes.region;
    }
    const status = "Closed";

    features.setAttributes({
      Status: status,
      CreatedBy: this.currentUser.username,
      CreationDate: new Date(Date.now()).getTime(),
      Region: region,
      AssetID: assetId,
      AssetName: this.selectedLayerName,
      WorkOrderDesc: "",
      Comment: "",
      CompletedBy: this.currentUser.username,
      CompletionDate: new Date(Date.now()).getTime(),
      GeomWKT: JSON.stringify(geomString),
      PendingChanges: JSON.stringify(this.generatePendingChangesForGeometryChange(this.rollbackData.Shape, asset.geometry)),
      ModifiedBy: this.currentUser.username,
      LastModifyDate: new Date(Date.now()).getTime()
    });
    featurese.push(features);

    this.ftrLyrTblMaintenance
      .applyEdits(featurese, null, null)
      .then(
        function (newrow) {
          // updateing MaintID for newly inserted Maintanance record
          const featureseAssetID = [];
          const featuresA = new this.Graphic();
          featuresA.setAttributes({
            OBJECTID: newrow[0].objectId,
            MaintID: "MNT_" + newrow[0].objectId
          });
          featureseAssetID.push(featuresA);
          this.ftrLyrTblMaintenance
            .applyEdits(null, featureseAssetID, null)
            .then(
              function () {
                console.log("reshaped");
              }.bind(this)
            )
            .catch(function (error) {
              // console.log("===============================================");
              console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
              // console.log("error = ", error);
            });
          // End
          const actfeaturese = [];
          const actfeatures = new this.Graphic();

          actfeatures.setAttributes({
            // updateing MaintID for newly inserted Maintanance record
            // "MaintID": newrow[0].objectId,
            MaintID: "MNT_" + newrow[0].objectId,
            Asset: this.assetTypeId,
            Activity: "Reshape",
            Description: " ",
            ModifiedBy: this.currentUser.username,
            LastModifyDate: new Date(Date.now()).getTime()
          });
          actfeaturese.push(actfeatures);
          this.ftrLyrActivity.applyEdits(actfeaturese, null, null).then(
            function () {
              // console.log(newrow);
              this.eeService.setreshapeTaskCreated(true);
            }.bind(this)
          );
          this.assetDetailService.assetChanged.emit(this.activeFeature);
        }.bind(this)
      )
      .catch(function (error) {
        // console.log("===============================================");
        console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
      });
  }

  SaveExistData() {
    this.cardViewService.getFeatures(this.eeService.activeAssetInfo[1].lyrObj.url, "ObjectID = " + this.eeService.activeAssetInfo[0].OBJECTID, this.Query, this.QueryTask).then((val) => {
      const result = val[0];
      // console.log(result);
      this.rollbackData = {};
      this.rollbackData = result.attributes;
      this.rollbackData.Shape = result.geometry;
    });
  }

  childLayerAccess(layerId: number) {   // called from html. this shoult not be needed as same check was done prior to adding data to childRelationshipInfo 
    return this.currentUser.assignedAssetClasses!.some(layer => layer.layerId === layerId);
  }

  
  openTasks: { [assetId: string]: number } = {};
  normalizeOpenTasks() {  //added for TSDRSAM-3115
    this.openTasks = {};
    this.openTasksJson?.OpenTaskByAsset.forEach ( assetType => {
      let props = Object.getOwnPropertyNames(assetType);
      props.forEach( assetTypeName => {

        assetType[assetTypeName].forEach (asset => {
          this.openTasks[asset.AssetId] = asset.OpenTaskCount;

          asset.Sign?.forEach( sign => {
            this.openTasks[sign.AssetId] = sign.OpenTaskCount;
          });

          asset.Light?.forEach( light => {
            this.openTasks[light.AssetId] = light.OpenTaskCount;
          });

        });
      });
    });
    console.log(this.openTasks);
  }

  public setReplaceYearData() {
    this.assetAttributesService.getElifeTableValues(this.currentUser.tableIds.baseLifeValuesId).subscribe((res: any) => {
      if (res.features.length > 0) {
        this.eeService.baseLifeValuesData = res;
      }
    });
    this.assetAttributesService.getElifeTableValues(this.currentUser.tableIds.modifierValueId).subscribe((res: any) => {
      if (res.features.length > 0) {
        this.eeService.modifierValueData = res;
      }
    });
    this.assetAttributesService.getElifeTableValues(this.currentUser.tableIds.modifierConfigId).subscribe((res: any) => {
      if (res.features.length > 0) {
        this.eeService.modifierConfig = res;
      }
    });
  }

  // Added by Abhilash for JIRA ID:-34 on 08/12/2021
  // Get sorted list of fields to display on the summary card
  getFieldsInfo() {
    try {
      this.activeAsset = this.eeService.activeAssetInfo;
      this.isDataEditor = this.userService.isDataEditorForRoleRegionAndLayer(this.currentUser, this.activeAsset[1].layerId); // was .lyrObj.layerId
      this.assetAttributesService.getFieldAlias().subscribe((results) => {
        this.result = results;
        if (this.result) {
          const columns = this.result.features.filter(
            (feature) =>
              //Jira Id-933
              feature.attributes.TableName.toLowerCase() === this.activeAsset[1].name.toLowerCase()
          );
          this.fieldsInfo = this.fieldsInfoData(columns, false);
          if (this.activeAsset[1].name === "Support") {
            // Mani 11/19/2021  Added if condition
            const columnsForLight = this.result.features.filter((feature) => feature.attributes.TableName === "Light");
            const columnsForSign = this.result.features.filter((feature) => feature.attributes.TableName === "Sign");

            this.fieldsInfoSign = this.fieldsInfoData(columnsForSign, true);
            this.fieldsInfoLight = this.fieldsInfoData(columnsForLight, true);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  // Added by Abhilash for JIRA ID:-34 on 08/12/2021
  fieldsInfoData(value, flag) {
    try {
      const fieldInfosdata = [];
      const CodedValues = {};
      if (!flag) {
        for (let ind = 0; ind < this.activeAsset[1].lyrObj._fields.length; ind++) {
          if (this.activeAsset[1].lyrObj._fields[ind].domain) {
            for (let index = 0; index < this.activeAsset[1].lyrObj._fields[ind].domain.codedValues.length; index++) {
              const val = this.activeAsset[1].lyrObj._fields[ind].domain.codedValues[index];
              CodedValues[val.code] = val.name;
            }
          }
        }
      }
      value.forEach((element) => {
        if (element.attributes.IsCardviewColumnVisible === 1) {
          fieldInfosdata.push({
            fieldName: element.attributes.Field,
            IsRequired: element.attributes.IsRequired,
            labelSL: element.attributes.FieldAlias_SL,
            label: element.attributes.FieldAlias,
            type: "esriFieldTypeString",
            FieldOrder: element.attributes.FieldOrder,
            codedValues: CodedValues,
            tableName: element.attributes.TableName,
            IsCardviewColumnVisible: element.attributes.IsCardviewColumnVisible
          });
        }
      });
      return fieldInfosdata.sort(function (a, b) {
        return a.FieldOrder - b.FieldOrder;
      });
    } catch (error) {
      console.error(error);
    }
  }

  // Added by Abhilash for JIRA ID:-34 on 08/12/2021
  getCodedValue(asset: any, relationshipName: string): string {
    let description = "";
    try {
      if (relationshipName === "SupportToSign" || relationshipName === "SupportToLight") {
        const types = relationshipName==="SupportToSign" ? this.genericMapMethodsService.signTypes : this.genericMapMethodsService.lightTypes;
        const codedValues = types.find((t: any) => t.id === asset.attributes.AssetSubType)?.domains["AssetCode"]?.codedValues;
        const codedValue = codedValues?.find((cv: any) => cv.code === asset.attributes.AssetCode);
        description = codedValue ? codedValue.code + " " + codedValue.name : "";
      }
    } catch (error) {
      console.error(error);
    }
    return description;
  }

  // Jira Id-34 Bug-TSDRSAM-1546.  fixed calls to getCodedValue, to include layer, so don't need this 'bug fix'.
  // getCodedValueForLight(asset): string {
  //   try {
  //     let description = "";
  //     for (let ind = 0; ind < this.genericMapMethodsService.lightTypes.length; ind++) {
  //       for (let i = 0; i < this.genericMapMethodsService.lightTypes[ind].domains["AssetCode"].codedValues.length; i++) {
  //         if (this.genericMapMethodsService.lightTypes[ind].domains["AssetCode"].codedValues[i].code == asset.attributes.AssetCode) {
  //           description = this.genericMapMethodsService.lightTypes[ind].domains["AssetCode"].codedValues[i].name;
  //         }
  //       }
  //     }
  //     return description;
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // JIRA ID:61
  minimizeAssetViewer() {
    try {
      this.isShown = !this.isShown;
      const assetDiv = document.querySelector("#assestDragDiv");
      if (!this.isShown) {
        assetDiv.setAttribute("style", "height: 100px;");  // just enough room for header AND footer to show.
        document.getElementById('cardview').style.height='fit-content';
      } else {
        assetDiv.setAttribute("style", "height: 100%;overflow:hidden; border-radius: none;");
        document.getElementById('cardview').style.height='100%';
      }
    } catch (error) {
      console.error(error);
    }
  }
  //HEADING LOGIC
  getCloseIcon() {
    return !this.eeService.addNewParent && !this.eeService.addNewChild ? "cross" : null;
  }

  getAssetAddIcon() {
    if (this.selectedLayerName == "Support" && this.currentUser.rolePermissions.assetAdd && (this.signAddAccess || this.lightAddAccess)) {
      //TSDRSAM-1911
      return this.currentUser.rolePermissions.assetAdd && !this.eeService.addNewParent && this.currentUser.selectedRegion.accessPrivilege === "Data Editor" ? "plus" : null;
    } else if (this.showreshape && !this.eeService.addNewParent && this.currentUser.rolePermissions.assetRelocate && !this.visualizationAssetIsActive) {
      return "draw";
    }

    return null;
  }
  getAssetAddTooltip() {
    if (this.selectedLayerName == "Support" && this.currentUser.rolePermissions.assetAdd && (this.signAddAccess || this.lightAddAccess)) {
      return this.currentUser.rolePermissions.assetAdd && this.currentUser.selectedRegion.accessPrivilege === "Data Editor" ? this.translateService.instant("Select.carddisplay.addasset") : null;
    } else if (this.showreshape && this.currentUser.rolePermissions.assetRelocate && !this.visualizationAssetIsActive) {
      return this.translateService.instant("Select.carddisplay.reshapebtn");
    }

    return null;
  }

  getRelocateAssetIcon() {
    return !this.eeService.addNewParent && this.currentUser.rolePermissions.assetRelocate && this.isDataEditor && this.eeService.activeAssetInfo[0].AssetID
      ? //TSDRSAM-1818: relocate icon was not availble for child asset
        // &&
        // !this.eeService.activeAssetInfo[0].AssetID.includes("SIG") &&
        // !this.eeService.activeAssetInfo[0].AssetID.includes("LGT")
        "add-query"
      : null;
  }
  //Visualization layers
  OpenVisualizationAssetDetail() {
    this.showAssetDetail();
  }

  //TSDRSAM-1426
  generatePendingChangesForGeometryChange(shapeBefore, shapeAfter) {
    let deltaResult = { before: { Shape: {} }, after: { Shape: {} } };

    deltaResult.before.Shape = shapeBefore;

    //remove unwanted attributes in geometry field
    if ("cache" in shapeAfter) {
      delete shapeAfter["cache"];
    }
    if ("_path" in shapeAfter) {
      delete shapeAfter["_path"];
    }
    deltaResult.after.Shape = shapeAfter;

    return deltaResult;
  }
  //TSDRSAM-1869
  EnableIcon(isEnable: boolean) {
    this.reshapeIconDiv = document.getElementById("draw");
    this.relocateIconDiv = document.getElementById("relocate");
    if (isEnable) {
      this.reshapeIconDiv?.classList.remove("not-active");
      this.relocateIconDiv?.classList.remove("not-active");
    } else {
      this.reshapeIconDiv?.classList.add("not-active");
      this.relocateIconDiv?.classList.add("not-active");
    }
  }
  //TSDRSAM-1911
  getMinMaxIcon() {
    if (!this.eeService.addNewParent) {
      return this.isShown == false ? "arrow-down" : "arrow-up";
    }
    return null;
  }
}

